import { defineComponent as b, useSlots as B, computed as S, openBlock as i, createBlock as s, unref as o, mergeProps as $, createSlots as T, withCtx as a, renderSlot as v, createElementVNode as l, createElementBlock as c, createVNode as p, resolveDynamicComponent as x, createCommentVNode as d, toDisplayString as u, normalizeClass as N, Fragment as D, createTextVNode as h } from "vue";
import "./ghl-ui.es23.js";
import "./ghl-ui.es173.js";
import I from "./ghl-ui.es174.js";
import L from "./ghl-ui.es175.js";
import V from "./ghl-ui.es176.js";
import k from "./ghl-ui.es72.js";
const F = { class: "hl-drawer-header-container" }, R = {
  key: 0,
  class: "hl-drawer-header-icon"
}, U = {
  key: 0,
  class: "hl-drawer-title"
}, j = {
  key: 1,
  class: "hl-drawer-description"
}, E = { class: "hl-drawer-action-left" }, q = { class: "hl-drawer-action-right" }, z = b({
  name: "UIDrawerContent",
  inheritAttrs: !1
}), A = b({
  ...z,
  props: {
    id: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: void 0
    },
    description: {
      type: String,
      default: void 0
    },
    icon: {
      type: Function,
      default: void 0
    },
    positiveText: {
      type: String,
      default: void 0
    },
    negativeText: {
      type: String,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    closable: {
      type: Boolean,
      default: !0
    },
    disableNegativeBtn: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["negativeClick", "positiveClick"],
  setup(e) {
    const f = e, t = B(), w = S(() => f.positiveText || f.negativeText || (t == null ? void 0 : t.actionLeft) || (t == null ? void 0 : t.actionRight));
    return (n, r) => (i(), s(o(L), $(n.$attrs, {
      closable: e.closable,
      class: "hl-drawer-content"
    }), T({
      default: a(() => [
        v(n.$slots, "default", {}, void 0, !0)
      ]),
      _: 2
    }, [
      e.title || e.description || e.icon ? {
        name: "header",
        fn: a(() => [
          l("div", F, [
            e.icon ? (i(), c("div", R, [
              p(o(V), null, {
                default: a(() => [
                  (i(), s(x(e.icon), { class: "w-5 h-5" }))
                ]),
                _: 1
              })
            ])) : d("", !0),
            l("div", null, [
              e.title ? (i(), c("div", U, u(e.title), 1)) : d("", !0),
              e.description ? (i(), c("div", j, u(e.description), 1)) : d("", !0)
            ])
          ])
        ]),
        key: "0"
      } : void 0,
      w.value ? {
        name: "footer",
        fn: a(() => {
          var m, y, g;
          return [
            l("div", {
              class: N([
                "hl-drawer-actions",
                (m = o(t)) != null && m.actionLeft ? "justify-between" : "justify-end	"
              ])
            }, [
              l("div", E, [
                (y = o(t)) != null && y.actionLeft ? v(n.$slots, "actionLeft", { key: 0 }, void 0, !0) : d("", !0)
              ]),
              l("div", q, [
                (g = o(t)) != null && g.actionRight ? v(n.$slots, "actionRight", { key: 0 }, void 0, !0) : (i(), c(D, { key: 1 }, [
                  e.negativeText ? (i(), s(o(k), {
                    key: 0,
                    id: `${e.id}-btn-negative-action`,
                    onClick: r[0] || (r[0] = (C) => n.$emit("negativeClick")),
                    disabled: e.disableNegativeBtn
                  }, {
                    default: a(() => [
                      h(u(e.negativeText), 1)
                    ]),
                    _: 1
                  }, 8, ["id", "disabled"])) : d("", !0),
                  e.positiveText ? (i(), s(o(k), {
                    key: 1,
                    id: `${e.id}-btn-positive-action`,
                    loading: e.loading,
                    disabled: e.disabled,
                    type: "primary",
                    onClick: r[1] || (r[1] = (C) => n.$emit("positiveClick"))
                  }, {
                    default: a(() => [
                      h(u(e.positiveText), 1)
                    ]),
                    _: 1
                  }, 8, ["id", "loading", "disabled"])) : d("", !0)
                ], 64))
              ])
            ], 2)
          ];
        }),
        key: "1"
      } : void 0
    ]), 1040, ["closable"]));
  }
}), Q = /* @__PURE__ */ I(A, [["__scopeId", "data-v-078ad534"]]);
export {
  Q as default
};
